import React from 'react'
import { mergeClasses } from '@/helpers/styling'
import { EDITOR_SIZES, EditorSize } from '@/components/editor/size-switch'
import { PanelChrome } from '@/components/editor/panels/panel-chrome'
import { useFloatingState } from '@/components/editor/panels/panel-registry'
import { useWidgetSelectorStore } from '@/components/editor/widget-selector/widget-selector'
import { resizeSettings } from '@/components/editor/widget-editor/settings-size'

/** An editor's sizes as panel header icons, the current one highlighted */
export function SizeHeaderIcons(props: {
  current?: EditorSize
  onResize: (size: EditorSize) => void
  /** Leaves out the sizes that make no sense for this editor */
  sizes?: EditorSize[]
}) {
  const floatingState = useFloatingState()
  const current = props.current ?? (floatingState === "docked" ? "docked" : "floating")
  const hasSelection = useWidgetSelectorStore(s => s.selectedPath != null)
  return (
    <>
      {EDITOR_SIZES.filter(({ size }) => !props.sizes || props.sizes.includes(size)).map(({ size, label, Icon }) => (
        <PanelChrome.HeaderIcon key={size}
                                title={size === "overlay" && !hasSelection ? `${label} (select a widget first)` : label}
                                icon={Icon}
                                disabled={size === "overlay" && !hasSelection}
                                onClick={() => size !== current && props.onResize(size)}
                                className={mergeClasses({
                                  "opacity-100 bg-muted": size === current && floatingState === "docked",
                                  "opacity-100 bg-white/25": size === current && floatingState !== "docked",
                                })} />
      ))}
    </>
  )
}

/** The widget settings' sizes */
export function SettingsSizeIcons(props: { current?: EditorSize }) {
  return <SizeHeaderIcons current={props.current} onResize={resizeSettings} />
}
